export const fmt = (n) =>
  n == null
    ? '—'
    : Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtN = (n) =>
  n == null ? '—' : Number(n).toLocaleString('en-US');

export function toDateObj(v) {
  if (v == null) return null;
  if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
  if (typeof v === 'number')
    return new Date(Math.round((v - 25569) * 86400 * 1000));
  const d = new Date(String(v));
  return isNaN(d.getTime()) ? null : d;
}

const DATE_COL_KW = ['date', 'dt', 'expir', 'maturity', 'settle', 'inception'];
const NUM_COL_KW = [
  'notional', 'value', 'amount', 'price', 'strike', 'premium', 'payoff',
  'units', 'options', 'quantity', 'qty', 'total', 'cash', 'proceeds',
  'coupon', 'rate', 'spread', 'cost', 'nav',
];

export function isDateCol(c) {
  const n = String(c).toLowerCase();
  return DATE_COL_KW.some((k) => n.includes(k));
}

export function isNumCol(c) {
  if (isDateCol(c)) return false;
  const n = String(c).toLowerCase();
  return NUM_COL_KW.some((k) => n.includes(k));
}

export function formatCell(col, val) {
  if (val == null || val === '') return '—';
  if (isDateCol(col)) {
    if (val instanceof Date) {
      return `${val.getMonth() + 1}/${val.getDate()}/${val.getFullYear()}`;
    }
    const s = String(val).trim().split('T')[0].split(' ')[0];
    return s || '—';
  }
  if (isNumCol(col)) {
    const n = parseFloat(String(val).replace(/,/g, ''));
    if (!isNaN(n))
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  return String(val);
}

export function applyDateFilter(rows, field, dateFrom, dateTo) {
  if (!rows || (!dateFrom && !dateTo)) return rows || [];
  const pd = (s) => {
    if (!s) return null;
    const p = String(s).split('/');
    return p.length === 3 ? new Date(+p[2], +p[0] - 1, +p[1]) : new Date(s) || null;
  };
  const from = dateFrom
    ? (() => { const p = dateFrom.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); })()
    : null;
  const to = dateTo
    ? (() => {
        const p = dateTo.split('-');
        const d = new Date(+p[0], +p[1] - 1, +p[2]);
        d.setHours(23, 59, 59, 999);
        return d;
      })()
    : null;
  return rows.filter((r) => {
    const d = pd(r[field]);
    if (!d) return true;
    if (from && d < from) return false;
    if (to && d > to) return false;
    return true;
  });
}

export const extractEntity = (v) => {
  if (!v) return null;
  const s = String(v).trim();
  const i = s.indexOf('-');
  return i >= 0 ? s.slice(i + 1).trim() : s;
};

/**
 * Normalise a trade/position identifier down to its numeric core so the
 * Milliman and Clearwater sides key the same way.
 *
 * Drops a trailing entity suffix (SBLI/SUSA/NWL), then any trailing
 * non-digits, then returns the longest run of digits that remains — so
 * "100392SBLI", "100392-1", "P-100392" and "TXN-100392-PYO" all collapse to
 * "100392". Returns "" when there are no digits at all.
 */
export const stripSuffix = (v) => {
  const s = String(v == null ? '' : v)
    .trim()
    .replace(/(SBLI|SUSA|NWL)$/i, '')
    .trim()
    .replace(/[^0-9]+$/, '')
    .trim();
  const runs = s.match(/\d+/g);
  // Only reachable when s is already '': the trailing non-digit strip above
  // consumes an all-non-digit identifier whole. Kept as `s` to mirror
  // recon_logic.py's strip_suffix line for line.
  if (!runs) return s;
  // Longest run wins; ties keep the leftmost, matching Python's max().
  return runs.reduce((best, cur) => (cur.length > best.length ? cur : best));
};

export function getVal(row, colName) {
  if (!row) return null;
  const t = String(colName).toLowerCase().trim();
  const k = Object.keys(row).find((kk) => kk.toLowerCase().trim() === t);
  return k ? row[k] : null;
}
